import React, { useState } from "react";
import { Button, Image } from "react-bootstrap";
import moment from "moment";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import ReadMoreReact from "read-more-react/dist/components/ReadMoreReact";
import EditOpenIssues from "../../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/InsideAllPageComponent/EditOpenIssues";
import { capitalize } from "lodash";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const OpenIssuesUsersTableBody = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  let data = props.data;
  return (
    <React.Fragment>
      <tbody>
        <tr className="super_admin_all_users_table_body">
          <td className="p-0 w-100">
            <table className="w-100 HideShowTable">
              <tbody>
                <tr className="cursor" onClick={showTr}>
                  <td style={{ width: "10%" }}>
                    <div className="f12-500">{data.ticket_number}</div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-500">
                      {data.itemType === "OFFER"
                        ? data?.offer_coupon_code
                        : data.seating_request_no ||
                          data?.order_request_no ||
                          data?.transaction_request_no ||
                          data?.event_request_no ||
                          data?.itemId?.requestId}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="super-admin-suggestion-table-body-boxone">
                      <div className="super-admin-suggestion-imageBoxOne enIMG33">
                        <Image
                          fluid
                          src={
                            data?.user_id === null
                              ? require("../../../../assets/images/ActionImages/demoprofile.jpg")
                              : data?.user_id?.profile_photo[0] ||
                                data?.user_id?.profile_photo?.length === 1
                              ? data?.user_id?.profile_photo[0]
                              : require("../../../../assets/images/ActionImages/demoprofile.jpg")
                          }
                          alt="Icon"
                        />
                      </div>
                    </div>
                    <div className="super-admin-suggestion-imageBoxTwo">
                      <div className="f11-400">{data?.user_id?.first_name}</div>
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="d-flex align-items-center">
                      {/* <div className="image-box-new mr-2">
                        <Image
                          fluid
                          width="20px"
                          // src={require("../../../../assets/images/seatingImages/reservationBlack.png")}
                          src={
                            data &&
                            data.diner_id &&
                            data.diner_id.service_type === "RESERVATION" &&
                            data &&
                            data.diner_id &&
                            data.diner_id.isWalkIn === false
                              ? require("../../../../assets/images/ActionImages/online-booking.svg")
                              : data &&
                                data.diner_id &&
                                data.diner_id.isWalkIn === true
                              ? require("../../../../assets/images/ActionImages/walking-img.svg")
                              : data &&
                                data.diner_id &&
                                data.diner_id.isWalkIn === false
                              ? require("../../../../assets/images/ActionImages/clock-circular-outline.svg")
                              : null
                          }
                        />
                      </div> */}
                      <div>
                        <div className="f10-400">
                          {data &&
                            data.ticket_category_id &&
                            data.ticket_category_id.title}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      <div className="d-flex align-items-center">
                        <div className="image-box-new mr-2">
                          <Image
                            fluid
                            width="20px"
                            // src={require("../../../../assets/images/seatingImages/reservationBlack.png")}
                            src={
                              data &&
                              data.ticket_sub_category_id &&
                              data.ticket_sub_category_id.title === "Waitlist"
                                ? require("../../../../assets/images/ActionImages/clock-circular-outline.svg")
                                : data &&
                                  data.ticket_sub_category_id &&
                                  data.ticket_sub_category_id.title ===
                                    "Walk in"
                                ? require("../../../../assets/images/ActionImages/walking-img.svg")
                                : data &&
                                  data.ticket_sub_category_id &&
                                  data.ticket_sub_category_id.service_type ===
                                    "Reservation"
                                ? require("../../../../assets/images/ActionImages/online-booking.svg")
                                : null
                            }
                          />
                        </div>
                        <div>
                          <div className="f10-400">
                            {data?.itemType === "EXP"
                              ? capitalize(data?.itemId?.expType)
                              : data?.ticket_sub_category_id?.title}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td id="read-more-text" style={{ width: "18%" }}>
                    <div className="f12-400">
                      <ReadMoreReact
                        text={data?.description}
                        min={0}
                        ideal={0}
                        max={data?.description?.length}
                        readMoreText={"Read More"}
                      />
                      {/* {data.description} */}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="d-flex align-items-center">
                      <div
                        className="f12-400"
                        // onClick={props.userTicketOpen(data._id)}
                        onClick={(e) =>
                          props.onFilterOpen(e, data.status, data._id)
                        }
                      >
                        {data.status === 0
                          ? "New"
                          : data.status === 1
                          ? "In-Progress"
                          : data.status === 2
                          ? "Awaiting - Feedback"
                          : data.status === 3
                          ? "On-Hold"
                          : data.status === 4
                          ? "ReOpened"
                          : data.status === 5
                          ? "Resolved"
                          : data.status === 6
                          ? "Closed"
                          : data.status === 7
                          ? "Archive"
                          : data.status === 8
                          ? "Called User"
                          : data.status === 9
                          ? "Completed"
                          : ""}
                      </div>
                      {
                        <i
                          className="ml-2 fa fa-angle-down"
                          aria-hidden="true"
                          onClick={(e) =>
                            props.onFilterOpen(e, data.status, data._id)
                          }
                          //onClick={() => onShowModal(issue.status, issue._id)}
                        ></i>
                      }
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      {moment(data.createdAt).format("Do MMM YYYY")}
                    </div>
                    <div className="f12-400">
                      {moment(data.createdAt).format("hh : mm A")}
                    </div>
                  </td>
                  <td style={{ width: "12%" }}>
                    <div className="d-flex align-items-center mt-3">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={() =>
                          props.sendInformationViewTicket(data._id)
                        }
                      >
                        <Image
                          fluid
                          alt="View"
                          title="View"
                          src={require("../../../../assets/images/UserManagement/eye.svg")}
                        />
                      </Button>
                      {data?.initiatedBy !== null &&
                      data?.initiatedBy !== undefined &&
                      data?.initiatedBy !== "" ? (
                        data?.initiatedBy === "VENDOR" ? (
                          <EditOpenIssues issueDetail={data} />
                        ) : (
                          <></>
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr className="border-top">
                    <td style={{ width: "20%" }}>
                      <div className="f12-700 pb-2">Uploaded Photos</div>
                      <div className="d-flex align-items-center">
                        {props.data &&
                          props.data.refrence_images &&
                          props.data.refrence_images.map((photo, index) => {
                            return (
                              <React.Fragment key={index}>
                                <SimpleReactLightbox>
                                  <SRLWrapper options={options}>
                                    <div className="enIMG33 rounded-circle mr-2">
                                      <Image fluid src={photo} alt="Icon" />
                                    </div>
                                  </SRLWrapper>
                                </SimpleReactLightbox>
                              </React.Fragment>
                            );
                          })}
                      </div>
                    </td>
                    <td style={{ width: "20%" }}>
                      <div className="f12-700 pb-2">Uploaded Videos</div>
                      <div className="d-flex align-items-center">
                        {props.data &&
                          props.data.refrence_videos &&
                          props.data.refrence_videos.map((video, index) => {
                            return (
                              <div className="col-4 mb-3" key={index}>
                                <video
                                  width="150"
                                  height="75"
                                  controls
                                  src={video && video}
                                  type="video/mp4"
                                />
                              </div>
                            );
                          })}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};
export default OpenIssuesUsersTableBody;
